<template lang="html">
  <div
    v-if="(testimonials || []).length > 0"
    ref="container"
    v-resize="onResize"
  >
    <v-layout
      wrap
      justify-center
    >
      <v-flex
        xs12
        class="display-2 my-4 font-weight-light text-"
      >
        What our clients say
      </v-flex>
      <v-flex shrink>
        <v-slide-group
          v-model="activeItem"
          center-active
          :show-arrows="showArrows"
          prev-icon="arrow_back"
          next-icon="arrow_forward"
        >
          <v-slide-item
            v-for="(testimonial, i) in testimonials"
            :key="i"
            v-slot="{ toggle }"
            class="si-testimonial-item"
          >
            <v-card
              v-if="testimonial"
              class="ma-4"
              :width="cardWidth"
              outlined
              @click="toggle"
            >
              <v-layout justify-center>
                <v-flex
                  shrink
                  pt-6
                  pb-0
                >
                  <v-avatar
                    color=""
                    size="120"
                  >
                    <v-img
                      v-if="testimonial.avatar"
                      :src="testimonial.avatar.src"
                      :lazy-src="testimonial.avatar.lazySrc"
                      aspect-ratio="1"
                      @load="onResize"
                    />
                    <svg
                      v-else
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      height="100px"
                      width="100px"
                      fill="#009688"
                      version="1.1"
                      x="0px"
                      y="0px"
                      viewBox="0 0 80 80"
                      style="enable-background:new 0 0 80 80;" 
                      xml:space="preserve"
                    ><g><path d="M37.9951,34.9795C37.9839,27.8213,32.1563,22,24.9951,22c-7.1685,0-13,5.8315-13,13   c0,6.3716,4.5796,11.7432,10.7769,12.8062c0.3379,4.5796-3.4448,8.4473-3.4854,8.4878c-0.3198,0.3223-0.3833,0.8193-0.1538,1.2109   C19.3154,57.8169,19.647,58,19.9956,58c0.0889,0,0.1787-0.0117,0.2671-0.0366C38.4082,52.9233,38.0313,35.9097,37.9951,34.9795z    M22.7646,55.0034c1.2285-2.0098,2.4482-4.9619,1.8926-8.2466c-0.0742-0.4409-0.4321-0.7788-0.8765-0.8276   C18.2021,45.3164,13.9951,40.6177,13.9951,35c0-6.0654,4.9346-11,11-11s11,4.9346,11,11c0,0.0195,0.0005,0.0391,0.002,0.0586   C36.0059,35.2104,36.6602,49.3257,22.7646,55.0034z" /><path d="M67.9951,34.9795C67.9839,27.8213,62.1563,22,54.9951,22c-7.1685,0-13,5.8315-13,13   c0,6.3716,4.5796,11.7432,10.7769,12.8062c0.3379,4.5796-3.4448,8.4473-3.4854,8.4878c-0.3198,0.3223-0.3833,0.8193-0.1538,1.2109   C49.3154,57.8169,49.647,58,49.9956,58c0.0889,0,0.1787-0.0117,0.2671-0.0366C68.4082,52.9233,68.0313,35.9097,67.9951,34.9795z    M52.7646,55.0034c1.2285-2.0098,2.4482-4.9619,1.8926-8.2466c-0.0742-0.4409-0.4321-0.7788-0.8765-0.8276   C48.2021,45.3164,43.9951,40.6177,43.9951,35c0-6.0654,4.9346-11,11-11s11,4.9346,11,11c0,0.0195,0.0005,0.0391,0.002,0.0586   C66.0059,35.2104,66.6602,49.3257,52.7646,55.0034z" /></g></svg>
                  </v-avatar>
                </v-flex>
              </v-layout>

              <v-card-text class="si-testimonial-text body-1">
                {{ testimonial.text }}
                <div class="mt-4">
                  <div class="text--primary">
                    {{ testimonial.name }}
                  </div>
                  <div class="text-subtitle-2">
                    {{ testimonial.title }}
                    <span v-if="testimonial.businessName">|
                      <a
                        v-if="testimonial.businessLink"
                        style="text-decoration: none;"
                        target="blank"
                        :href="testimonial.businessLink"
                      >
                        {{ testimonial.businessName }}
                      </a>
                      <span v-else>{{ testimonial.businessName }}</span>
                    </span>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-slide-item>
        </v-slide-group>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { rtdb } from '@/plugins/firebase'
import helpers from '@/mixins/helpers'

export default {
  mixins: [ helpers ],
  props: {
    displayGroupName: String

  },
  data () {
    return {
      activeItem: null,
      cardWidth: 600,
      showArrows: true,
      testmonialItems: {},
      displayGroup: [],
    }
  },
  computed: {
    ...mapGetters(['_pageLayout']),
    testimonials () {
      return this.displayGroup.map(id => this.testmonialItems[id])
    }
  },
  beforeMount () {
    rtdb.ref(`site/testimonials`).once('value', s => {
      let { items, displayGroups = {} } = s.val() || {}
      this.testmonialItems = items || {}
      this.displayGroup = displayGroups[this.displayGroupName] || []
      this.$nextTick(this.onResize)
      setTimeout(this.onResize, 500)
    })
  },
  mounted () {
    this.$nextTick(this.onResize)
  },
  methods: {
    onResize () {
      let multiplier = 1
      let container = this.$refs.container
      if (!container) return
      let wrapper = container.getElementsByClassName('v-slide-group__wrapper')[0]
      let containerWidth = container.clientWidth
      let wrapperWidth = wrapper.clientWidth

      if (containerWidth >= 1055) multiplier = 2
      if (containerWidth >= 1500) multiplier = 3
      this.cardWidth = Math.max((wrapperWidth / multiplier) - 32, multiplier > 1 ? 400 : 0)
      this.showArrows = containerWidth > 600
    },
  }
}
</script>

<style lang="css" scoped>
.si-testimonial-text {
  /* white-space: normal; */
  white-space: pre-line
  /* color: inherit !important; */
}
.si-testimonial-item::before {
  display: none;
}
</style>
